import {UIGameCardController} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardController'
import {UIGameCardWithRatioContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardWithRatioContainerView'

export class UIWGameCardController extends UIGameCardController {
    protected getCardContainerView(): UIGameCardWithRatioContainerView {
        const canvas = this.uiGameManager.canvasController
        const x = 0
        const y = canvas.appH - canvas.bottomViewHeight
        const h = canvas.bottomViewHeight

        const containerWidthWithoutButtons = canvas.appW - canvas.chatWidth
        const containerWidthWithButtons = canvas.appW - canvas.itemSize * 10
        const isSpectator = this.uiGameManager.gameController.isPlayerSpectator || this.uiGameManager.gameController.isReplay

        const w = isSpectator ? containerWidthWithoutButtons : containerWidthWithButtons

        return new UIGameCardWithRatioContainerView(this.uiGameManager, x, y, w, h, canvas.app.stage)
    }
}
